import type { IMediaItemSchema, IMediaSchema, IMediumAssetSchema } from '../interface';

function addAsset(item: IMediaItemSchema, asset: IMediumAssetSchema): void {
    item.versions.push(asset);
}

function _checkMatch(item: IMediumAssetSchema, compare: Partial<IMediumAssetSchema>): boolean {
    if (compare.bitrate !== item.bitrate) {
        return false;
    } else if (compare.mimeType !== item.mimeType) {
        return false;
    } else if (compare.path !== item.path) {
        return false;
    } else if (compare.creationDate !== item.creationDate) {
        return false;
    } else if (compare.size !== item.size) {
        return false;
    } else if (compare.prefix !== item.prefix) {
        return false;
    } else if (compare.attributes !== item.attributes) {
        return false;
    } else {
        return true;
    }
}

function removeAsset(item: IMediaItemSchema, asset: Partial<IMediumAssetSchema>): void {
    item.versions = item.versions.filter(assetCheck => !_checkMatch(assetCheck, asset));
}

function addItem(schema: IMediaSchema, item: IMediaItemSchema): void {
    schema.media.push(item);
}

function findItem(schema: IMediaSchema, matchMediumId: string): IMediaItemSchema | undefined {
    return schema.media.find(item => item.sourceGuid === matchMediumId);
}

function updateItem(schema: IMediaSchema, item: IMediaItemSchema, matchMediumId: string): void {
    schema.media = [...schema.media.filter(item_ => item_.sourceGuid !== matchMediumId), item];
}

export default Object.freeze({
    addItem,
    findItem,
    updateItem,
    mediaItem: {
        removeAsset,
        addAsset,
    },
});
